import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import API_BASE_URL from "../../../../Constants";
import { useAuth } from '../../../../contexts/AuthContext';

const EditTroubleCallForm = () => {
    const navigate = useNavigate();
    const { user } = useAuth();
    const { id } = useParams();
    const [formData, setFormData] = useState({
        callNumber: '',
        buildingSite: '',
        customer: '',
        caller: '',
        superintendent: '',
        manager: '',
        phoneNumber: '',
        status: '',
        priority: '',
        problemClass: '',
        sub: '',
        dispatchNumber: '',
    });



    const [eventSRC, setEventSRC] = useState(null);

    useEffect(() => {
        const eventSource = new EventSource(`${API_BASE_URL}/sse/subscribe?username=${encodeURIComponent(user.username)}`);
        setEventSRC(eventSource);

        eventSource.onmessage = (event) => {
            alert(event.data);

        };

        eventSource.onerror = (err) => {
            console.error('EventSource failed:', err);
            eventSource.close();
        };

        return () => {
            eventSource.close();
        };
    }, [user]);


    // componentUnmount useEffect
    useEffect(() => {
        return () => {
            if (eventSRC) {
                eventSRC.close();
            }
        };
    }, [eventSRC]);

    useEffect(() => {
        const handleBeforeUnload = (event) => {
            // Call API to unlock the record
            clearUserLocks(user.username)
            // Optional: Show a confirmation dialog to the user
            event.preventDefault();
            event.returnValue = ''; // This is necessary for the dialog to show up
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
            clearUserLocks(user.username)
        };
    }, []);

    // API CALL TO NOTIFY REQUESTERS
    const notifyRequesters = async (recordId) => {
        try {
            const response = await fetch(`${API_BASE_URL}/api/notify/requesters?recordId=${encodeURIComponent(recordId + "-troublecalllist")}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },

                credentials: 'include',

            });

            if (response.ok) {
                const message = await response.text();
                console.log('Server response:', message);
            } else {
                throw new Error('Failed to notify requesters');
            }
        } catch (error) {
            console.error('An error occurred:', error.message);
        }
    }



    const clearUserLocks = async (user) => {
        try {
            const response = await fetch(`${API_BASE_URL}/api/record/${encodeURIComponent(user)}/clear-locks`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
            });

            if (response.ok) {
                const message = await response.text(); // Get the response message
                console.log('Server response:', message); // Logs the response from the server
                // notify all users that the record has been unlocked by post request
                // notify all the requesters for that particular record they requested is open
                notifyRequesters(id);


            } else {
                throw new Error('Failed to clear locks');
            }
        } catch (error) {
            console.error('An error occurred:', error.message);
        }
    };


    useEffect(() => {
        const fetchTroubleCall = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/api/callcenter/troublecalls/troubleCalls/${id}`, {
                    credentials: 'include',
                });
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const data = await response.json();
                setFormData(data);
            } catch (error) {
                console.error('Fetch error:', error);
            }
        };

        fetchTroubleCall();
    }, [id]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log(user.username);
        const updateData = {};
        Object.keys(formData).forEach(key => {
            if (formData[key]) {
                updateData[key] = formData[key];
            }
        });
        try {
            const response = await fetch(`${API_BASE_URL}/api/callcenter/troublecalls/edit-troublecall/${id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
                body: JSON.stringify(updateData),
            });

            if (response.ok) {
                alert('Trouble call edited successfully');
                clearUserLocks(user.username);
                navigate('/call-center/troublecallentry');
            } else {
                throw new Error('Failed to edit trouble call');
            }
        } catch (error) {
            console.error('Error editing trouble call:', error);
            alert('An error occurred while editing trouble call');
        }
    };

    return (
        <div className="max-w-4xl mx-auto mt-10 p-6 gradient-bg rounded-xl shadow-lg">
            <h2 className="text-2xl font-bold mb-6 text-left text-white">Edit Trouble Call ID: {id}</h2>
            <form onSubmit={handleSubmit}>
                <div className="flex items-start mb-6">
                    <div className="flex-1 grid grid-cols-2 gap-4">
                        <div className="col-span-1">
                            <label className="block text-gray-100">Call Number:</label>
                            <input
                                type="text"
                                name="callNumber"
                                value={formData.callNumber || ''}
                                onChange={handleInputChange}
                                className="w-full px-3 py-2 border rounded-md"
                            />
                        </div>
                        <div className="col-span-1">
                            <label className="block text-gray-100">Building Site:</label>
                            <input
                                type="text"
                                name="buildingSite"
                                value={formData.buildingSite || ''}
                                onChange={handleInputChange}
                                className="w-full px-3 py-2 border rounded-md"
                            />
                        </div>
                        <div className="col-span-1">
                            <label className="block text-gray-100">Customer:</label>
                            <input
                                type="text"
                                name="customer"
                                value={formData.customer || ''}
                                onChange={handleInputChange}
                                className="w-full px-3 py-2 border rounded-md"
                            />
                        </div>
                        <div className="col-span-1">
                            <label className="block text-gray-100">Caller:</label>
                            <input
                                type="text"
                                name="caller"
                                value={formData.caller || ''}
                                onChange={handleInputChange}
                                className="w-full px-3 py-2 border rounded-md"
                            />
                        </div>
                        <div className="col-span-1">
                            <label className="block text-gray-100">Superintendent:</label>
                            <input
                                type="text"
                                name="superintendent"
                                value={formData.superintendent || ''}
                                onChange={handleInputChange}
                                className="w-full px-3 py-2 border rounded-md"
                            />
                        </div>
                        <div className="col-span-1">
                            <label className="block text-gray-100">Manager:</label>
                            <input
                                type="text"
                                name="manager"
                                value={formData.manager || ''}
                                onChange={handleInputChange}
                                className="w-full px-3 py-2 border rounded-md"
                            />
                        </div>
                        <div className="col-span-1">
                            <label className="block text-gray-100">Phone Number:</label>
                            <input
                                type="text"
                                name="phoneNumber"
                                value={formData.phoneNumber || ''}
                                onChange={handleInputChange}
                                className="w-full px-3 py-2 border rounded-md"
                            />
                        </div>
                        <div className="col-span-1">
                            <label className="block text-gray-100">Status:</label>
                            <input
                                type="text"
                                name="status"
                                value={formData.status || ''}
                                onChange={handleInputChange}
                                className="w-full px-3 py-2 border rounded-md"
                            />
                        </div>
                        <div className="col-span-1">
                            <label className="block text-gray-100">Priority:</label>
                            <select
                                name="priority"
                                value={formData.priority}
                                onChange={handleInputChange}
                                className="w-full px-3 py-2 border rounded-md"
                            >
                                <option value="">Select an option</option>
                                {['1 (HIGH)', '2', '3', '4', '5 (LOW)'].map((option) => (
                                    <option key={option} value={option}>
                                        {option}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="col-span-1">
                            <label className="block text-gray-100">Problem Class:</label>
                            <select
                                name="problemClass"
                                value={formData.problemClass}
                                onChange={handleInputChange}
                                className="w-full px-3 py-2 border rounded-md"
                            >
                                <option value="">Select an option</option>
                                {['ENTRAPMENT',
                                    'SHUTDOWN',
                                    'PROBLEM',
                                    'FOLLOW UP',
                                    'PRE-SCHEDULED JOB',
                                    'INSPECTIONS',
                                    'AM SERVICE',
                                    'MOBILE SURVEY ITEMS',
                                    'Planning & Mobilization',
                                    'STANDBY',
                                    'MECHANIC INFORMED'].map((option) => (
                                        <option key={option} value={option}>
                                            {option}
                                        </option>
                                    ))}
                            </select>
                        </div>

                        <div className="col-span-1">
                            <label className="block text-gray-100">Sub:</label>
                            <select
                                name="sub"
                                value={formData.sub}
                                onChange={handleInputChange}
                                className="w-full px-3 py-2 border rounded-md"
                            >
                                <option value="">Select an option</option>
                                {['DOOR PROBLEM',
                                    'NOT RESPONDING TO CALLS',
                                    'ENTRAPMENT',
                                    'OFF LEVEL',
                                    'DOORS STUCK OPEN',
                                    'DOORS STUCK CLOSED',
                                    'PENDING APPROVAL OF PROPOSAL',].map((option) => (
                                        <option key={option} value={option}>
                                            {option}
                                        </option>
                                    ))}
                            </select>
                        </div>

                        <div className="col-span-1">
                            <label className="block text-gray-100">Dispatch Number:</label>
                            <input
                                type="text"
                                name="dispatchNumber"
                                value={formData.dispatchNumber || ''}
                                onChange={handleInputChange}
                                className="w-full px-3 py-2 border rounded-md"
                            />
                        </div>
                    </div>
                </div>
                <button
                    type="submit"
                    className="w-full py-2 px-4 bg-blue-500 text-white font-semibold rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400"
                >
                    Edit Trouble Call
                </button>
            </form>
        </div>
    );
};

export default EditTroubleCallForm;
